import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    TextField,
    Stack,
    Chip,
    MenuItem,
    Select,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import QAParametersModal from "../../../components/commonQA";
import EntityConfigModal from "../../../components/commonEntities";
import MetricsModal from "../../../components/commonMatrics";
import OnboardClientModal from "../../../components/clientOnborading";
import { jwtDecode } from "jwt-decode";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axiosInstance from "../../../services/axiosInterceptors";
import { useNavigate } from "react-router-dom";

const ClientManagement = () => {
    const [searchText, setSearchText] = useState("");
    const [openQA, setOpenQA] = useState(false);
    const [openMetrics, setOpenMetrics] = useState(false);
    const [openEntities, setOpenEntities] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [openOnboard, setOpenOnboard] = useState(false);
    const [clientData, setClientData] = useState([]);
    const token = localStorage.getItem("token");
    const decodedToken = token ? jwtDecode(token) : "";
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();


    const fetchClientData = async (data) => {
        try {
            const res = await axiosInstance.get(
                apiEndPointsConfig?.clientList,
                // data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setClientData(res?.data?.data);
            setLoading(false);
        } catch (error) {
            const statusCode = error?.response?.data?.status?.code;
            if (statusCode === 401) {
                localStorage.clear();
            } else {
                console.error("Error while fetching dashboard details :", error);
            }
        }
    };
    const updateClientData = async (payload) => {
        try {
            await axiosInstance.patch(
                apiEndPointsConfig?.updateCompanyData,
                payload,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // Refresh list after update
            fetchClientData();
        } catch (error) {
            console.error("Update failed", error);
        }
    };

    useEffect(() => {
        fetchClientData();
    }, []);

    const handleEntitiesToggle = (client) => {
        updateClientData({
            companyId: client.companyId,
            entitiesTab: !client.entitiesTab,
            sstModel: client.sstModel
        });
    };

    const handleConversionInsightToggle = (client) => {
        if (client.processType?.toLowerCase() !== "sales") return;
        updateClientData({
            companyId: client.companyId,
            entitiesTab: client.entitiesTab,
            sstModel: client.sstModel,
            conversionTab: !client.conversionTab
        });
    };

    const handleSstModelChange = (client, value) => {
        updateClientData({
            companyId: client.companyId,
            entitiesTab: client.entitiesTab,
            sstModel: value
        });
    };

    const sstModelName = [
        { label: "Azure", value: "Azure" },
        { label: "Azure MAI", value: "AzureMai" },
        { label: "Sarvam", value: "Sarvam" },
        { label: "DeepGram", value: "deepGram" },
        { label: "ElevenLab", value: "ElevenLab" },
        { label: "Assembly AI", value: "AssemblyAi" }
    ];



    const filteredClients = clientData?.filter((client) =>
        client.companyName.toLowerCase().includes(searchText.toLowerCase())

    );

    return (
        <Box sx={{ backgroundColor: "#f9fafb", minHeight: "80vh", p: 3 }}>
            {/* Client List Card */}
            <Paper
                elevation={0}
                sx={{ p: 3, borderRadius: 3, backgroundColor: "#fff" }}
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ mb: 2 }}
                >
                    <Typography variant="h6" fontWeight="bold">
                        Client List
                    </Typography>
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <TextField
                            size="small"
                            placeholder="Search clients..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            sx={{ width: 260 }}
                        />
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            sx={{
                                textTransform: "none",
                                backgroundColor: "#7635dc",
                                "&:hover": { backgroundColor: "#5b2da7e0" },
                            }}
                            onClick={() => setOpenOnboard(true)}
                        >
                            Add New Client
                        </Button>
                    </Stack>
                </Stack>

                {/* Table */}
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: "bold" }}>Company Name</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Contact Person</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Contact No.</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Process Type</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Entities Tab</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Conversion Insight Tab</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>STT model</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>QA Parameters</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Entities</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>OverView</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>CustomerInsight</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>AgentInsight</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Rediarization</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Conversion Insight</TableCell>
                                {/* <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell> */}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredClients.map((client, index) => (
                                <TableRow key={index}>
                                    <TableCell>{client.companyName}</TableCell>
                                    <TableCell>{client.contactPerson}</TableCell>
                                    <TableCell>{client.phone}</TableCell>
                                    <TableCell>{client.processType}</TableCell>
                                    <TableCell>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            color={client.entitiesTab ? "success" : "error"}
                                            onClick={() => handleEntitiesToggle(client)}
                                        >
                                            {client.entitiesTab ? "Enabled" : "Disabled"}
                                        </Button>

                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            color={client.conversionTab ? "success" : "error"}
                                            disabled={client.processType !== "sales"}
                                            onClick={() => handleConversionInsightToggle(client)}
                                        >
                                            {client.conversionTab ? "Enabled" : "Disabled"}
                                        </Button>

                                    </TableCell>
                                    <TableCell>
                                        <Select
                                            size="small"
                                            value={client.sstModel || "Azure"}
                                            onChange={(e) => handleSstModelChange(client, e.target.value)}
                                            fullWidth
                                        >
                                            {sstModelName.map((model) => (
                                                <MenuItem key={model.value} value={model.value}>
                                                    {model.label}
                                                </MenuItem>
                                            ))}
                                        </Select>

                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={"qa-parameter"}
                                            clickable
                                            sx={{ cursor: "pointer", backgroundColor: "#7635dc", color: "white" }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/qa-parameter-prompt/${client.companyId}/${client.processType}`
                                                )
                                            }
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <Chip
                                            label={"enities"}
                                            clickable
                                            sx={{ cursor: "pointer", backgroundColor: "#7635dc", color: "white" }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/entities-prompt/${client.companyId}/${client.processType}`
                                                )
                                            }
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <Chip
                                            label={"overView"}
                                            clickable
                                            sx={{ cursor: "pointer", backgroundColor: "#7635dc", color: "white" }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/overview-prompt/${client.companyId}/${client.processType}`
                                                )
                                            }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={"customerInsight"}
                                            clickable
                                            sx={{ cursor: "pointer", backgroundColor: "#7635dc", color: "white" }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/customer-insight-prompt/${client.companyId}/${client.processType}`
                                                )
                                            }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={"agentInsight"}
                                            clickable
                                            sx={{ cursor: "pointer", backgroundColor: "#7635dc", color: "white" }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/agent-insight-prompt/${client.companyId}/${client.processType}`
                                                )
                                            }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={"rediarization"}
                                            clickable
                                            sx={{ cursor: "pointer", backgroundColor: "#7635dc", color: "white" }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/rediarization-prompt/${client.companyId}/${client.processType}`
                                                )
                                            }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={"ConversionInsight"}
                                            clickable
                                            disabled={client.processType?.toLowerCase() !== "sales"}
                                            sx={{
                                                cursor:
                                                    client.processType?.toLowerCase() === "sales"
                                                        ? "pointer"
                                                        : "not-allowed",
                                                backgroundColor:
                                                    client.processType?.toLowerCase() === "sales"
                                                        ? "#7635dc"
                                                        : "#d1d5db",
                                                color:
                                                    client.processType?.toLowerCase() === "sales"
                                                        ? "white"
                                                        : "#6b7280",
                                            }}
                                            onClick={() =>
                                                navigate(
                                                    `/super-admin/conversion-insight-prompt/${client.companyId}/${client.processType}`
                                                )
                                            }
                                        />
                                    </TableCell>

                                    {/* <TableCell>
                                        <IconButton size="small">
                                            <MoreVertIcon />
                                        </IconButton>
                                    </TableCell> */}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            {/* Modals */}
            {/* <QAParametersModal
                open={openQA}
                setOpenQA={setOpenQA}
                onClose={() => setOpenQA(false)}
                processName={selectedClient?.companyName}
            /> */}
            {/* <MetricsModal
                open={openMetrics}
                onClose={() => setOpenMetrics(false)}
                processName={selectedClient?.companyName}
            /> */}
            {/* <EntityConfigModal
                open={openEntities}
                onClose={() => setOpenEntities(false)}
                processName={selectedClient?.companyName}
            /> */}
            <OnboardClientModal open={openOnboard} onClose={() => setOpenOnboard(false)} />
        </Box>
    );
};

export default ClientManagement;
